import './index.scss'
import React from 'react'
import { connect } from 'react-redux'
import { userSettingsAddLayer, userSettingsRemoveLayer, userSettingsSet, userSettingsUpdateRequest } from '../../../../../action/user-settings-actions'
import ProBlocker from '../../../common/pro-blocker'
import { fetchVendorObjects } from '../../../../../action/vendor-actions'
import { activeVendorsAdd, activeVendorsDelete } from '../../../../../action/active-vendors'
import { showMapObjects, hideMapObjects } from '../../../../../lib/util'
import { setUserPreferences } from '../../../../../action/user-preferences'
import LayerNodeDescription from './tooltip'
import { multiTileHuntLayers } from '../../../../hunt-planner/huntplanner-layer-render/renderlayerFunction'

class Layer extends React.Component {
  constructor(props) {
    super(props)
    this.shouldBlock = this.shouldBlock.bind(this)
  }

  shouldBlock() {
    const { userSubscriptions, layer } = this.props,
      hasSub = userSubscriptions.some(plan => {
        const check = plan.subscriptionPlanId & layer.subscriptionPlanIdFlag
        return check !== 0
      })
    return !hasSub
  }

  shouldHide() {
    const { userSubscriptions, layer } = this.props
    if (!layer.hideIfSubscriptionFlag && !layer.hideIfPaid) {
      return false
    }
    const hasSub = userSubscriptions.some(plan => {
      if (plan.subscriptionPlanId === 4 && layer.hideIfPaid) {
        return true
      }
      const check = plan.subscriptionPlanId & layer.hideIfSubscriptionFlag
      return check !== 0
    })
    return hasSub
  }

  checkForHuntPlanner() {
    let { selectedTab, huntplannerActiveLayerPayload } = this.props
    if (selectedTab == "huntplanner") {
      setTimeout(() => {
        // console.log('this is not wanted i guess pavan layer')
        // multiTileHuntLayers(
        //   huntplannerActiveLayerPayload.mapObj,
        //   huntplannerActiveLayerPayload.mapObjVal,
        //   huntplannerActiveLayerPayload.filter,
        //   huntplannerActiveLayerPayload.tile,
        //   huntplannerActiveLayerPayload.layerApi,
        //   huntplannerActiveLayerPayload.params,
        //   huntplannerActiveLayerPayload.layerData,
        //   huntplannerActiveLayerPayload.callback,
        // )
      }, 1000)
    }
  }

  render() {
    const { active, layer, vendors, settingId, favoriteLayers, mapReference, setUserPreferences,
      userSettingsAddLayer, userSettingsRemoveLayer, activeVendorsAdd, activeVendorsDelete, favoriteLayersSelect, activeLayers } = this.props,
      isFavorite = favoriteLayers && favoriteLayers.indexOf(layer.id) !== -1,
      blockLayer = this.shouldBlock()

    if (layer.hideInLayerMenu || !layer.enabled || this.shouldHide()) {
      return null
    }
    return (
      <>
        {(this.props.productionLayers && layer.production) || !this.props.productionLayers ? <div className={`layer-container ${active ? 'layer-container-active' : ''}`}
          onClick={(e) => {
            e.stopPropagation()
            const { activeLayers, layersDictionary } = this.props
            this.checkForHuntPlanner()
            if (active) {
              if (layer.layerNodeId !== 5) {
                if (favoriteLayersSelect == 'favoriteLayers') {
                  userSettingsRemoveLayer(settingId, layer.id)
                } else {
                  userSettingsRemoveLayer(settingId, layer.id)
                }
                if (layer.vendorId) {
                  activeVendorsDelete(layer.vendorId)
                  const measures = ['lines', 'markers', 'photos', 'tracks', 'circles', 'polygons'],
                    vendor = vendors[layer.vendorId]
                  if (vendor && vendor['objects']) {
                    measures.forEach(type => hideMapObjects(vendor['objects'][type]))
                  }
                }
              } else {
                userSettingsRemoveLayer(settingId, layer.id)
                  .then(() => {
                    userSettingsAddLayer(settingId, 81)
                  })
              }
            } else if (!active) {
              if (layer.layerNodeId !== 5) {
                if (favoriteLayersSelect == 'favoriteLayers') {
                } else {
                  userSettingsRemoveLayer(settingId, layer.id)
                }
                const filterable = activeLayers.find(id => layersDictionary[id].filterOnUnit)
                if (layer.filterOnUnit && filterable) {
                  userSettingsRemoveLayer(settingId, filterable)
                    .then(() => {
                      userSettingsAddLayer(settingId, layer.id)
                    })
                } else {
                  if (layer.vendorId && !vendors[layer.vendorId]) {
                    this.props.fetchVendorObjects(layer)
                      .then(() => {
                        activeVendorsAdd(layer.vendorId)
                      })
                  } else if (vendors[layer.vendorId]) {
                    activeVendorsAdd(layer.vendorId)
                    const measures = ['lines', 'markers', 'photos', 'tracks', 'circles', 'polygons'],
                      vendor = vendors[layer.vendorId]
                    if (vendor && vendor['objects']) {
                      measures.forEach(type => showMapObjects(vendor['objects'][type], mapReference))
                    }
                  }
                  userSettingsAddLayer(settingId, layer.id)
                }
              } else {
                const basemap = this.props.activeLayers.find(id => this.props.layersDictionary[id] && this.props.layersDictionary[id].layerNodeId === 5 && id !== layer.id)
                userSettingsRemoveLayer(settingId, basemap)
                  .then(() => {
                    setUserPreferences({ selectedTopo: layer.id })
                    userSettingsAddLayer(settingId, layer.id)
                  })
              }
            }
          }}
        >
          {
            layer.layerNodeId !== 5 ? (
              <div onClick={(e) => {
                e.stopPropagation()
                if (isFavorite) {
                  userSettingsRemoveLayer(2, layer.id)
                }
                else {
                  userSettingsAddLayer(2, layer.id)
                }
              }}
                className={isFavorite ? 'layer-favorite-btn-active' : 'layer-favorite-btn'}>
              </div>
            ) : null
          }
          <div className='layer-node-container'>
            <img src={layer.largeImageUrl ? layer.largeImageUrl :
              layer.imageUrl ? layer.imageUrl : ''}
              // style={{ width: 100, height: 100 }}
              className='layer-node-image'
            ></img>
            <div className='layer-node-text-container'>
              <div className='layer-node-header-container' style={{ top: layer.layerNodeId === 5 ? '100%' : '' }}>
                <span className='layer-label'>{layer.name}</span>
              </div>
              {/* <div className='layer-node-description' style={{}}>
                <span title={layer.description} className='layer-label'> {layer.description}</span>
              </div> */}
              <LayerNodeDescription layer={layer} parent={false}></LayerNodeDescription>
            </div>

          </div>

          {
            blockLayer ? <ProBlocker /> : null
          }
        </div> : ''}
      </>
    )
  }
}

const mapStateToProps = state => ({
  vendors: state.vendors,
  mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
  userSubscriptions: state.user.userSubscription ? state.user.userSubscription : [],
  userSettings: state.userSettings,
  activeLayers: state.userSettings.find(setting => setting.settingId === 1) ?
    state.userSettings.find(setting => setting.settingId === 1).valueArray : [],
  favoriteLayers: state.userSettings.find(setting => setting.settingId === 2) ?
    state.userSettings.find(setting => setting.settingId === 2).valueArray : [],
  layersDictionary: state.layersDictionary,
  productionLayers: state.productionLayers,
  selectedTab: state.selectedTab,
  huntplannerActiveLayerPayload: state.huntplannerActiveLayerPayload
})

const mapDispatchToProps = dispatch => ({
  activeVendorsAdd: id => dispatch(activeVendorsAdd(id)),
  activeVendorsDelete: id => dispatch(activeVendorsDelete(id)),
  fetchVendorObjects: id => dispatch(fetchVendorObjects(id)),
  userSettingsAddLayer: (setting, id) => dispatch(userSettingsAddLayer(setting, id)),
  userSettingsUpdateRequest: (setting, id) => dispatch(userSettingsUpdateRequest(setting, id, false)),
  userSettingsRemoveLayer: (setting, id) => dispatch(userSettingsRemoveLayer(setting, id)),
  userSettingsSet: settings => dispatch(userSettingsSet(settings)),
  setUserPreferences: obj => dispatch(setUserPreferences(obj))
})

export default connect(mapStateToProps, mapDispatchToProps)(Layer)
